import { FaRegCircle } from 'react-icons/fa6';

export const Unchecked = () => {
	/*********************
	// #region Redux
	**********************/

	return (
		<div className="text-white">
			<FaRegCircle />
		</div>
	);
};
